module.exports = __webpack_public_path__ + "static/media/sprite_compact-indicator.454dc1d0.svg";